import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export const KineticLines = ({ lines, className = '', lineClassName = '', delay = 0.2 }) => (
  <h1 className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden py-[0.06em]">
        <motion.div
          initial={{ y: '115%' }}
          animate={{ y: '0%' }}
          transition={{ duration: 1, delay: delay + i * 0.12, ease: EASE }}
          className={lineClassName}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </h1>
);

export const FadeUp = ({ children, delay = 0, className = '', once = true }) => (
  <motion.div
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: '-80px' }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <span className="inline-flex items-center gap-3 text-[11px] md:text-xs font-medium uppercase tracking-[0.3em] text-[#FF5C00]">
    <span className="h-px w-8 bg-[#FF5C00]" />
    {children}
  </span>
);
